import { useStorageClipboard } from "./use_storage_clipboard";

const TEXT_EDITOR_CLIPBOARD_STORAGE_KEY = "textEditorClipboard";
const TEXT_EDITOR_CLIPBOARD_TTL_MS = 60 * 60 * 1000; // 1 hour
const TEXT_EDITOR_CLIPBOARD_CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export const useTextEditorClipboard = () => {
	return useStorageClipboard({
		storageKey: TEXT_EDITOR_CLIPBOARD_STORAGE_KEY,
		ttlMs: TEXT_EDITOR_CLIPBOARD_TTL_MS,
		checkIntervalMs: TEXT_EDITOR_CLIPBOARD_CHECK_INTERVAL_MS,
		parseErrorMessage: "Cannot parse text editor clipboard:",
		syncErrorMessage: "Cannot sync text editor clipboard:",
	});
};
